export class Internet {
  constructor({
    internetID = 0,
    orderID = 0,
    internetType = null,
    ratePlanID = 0,
    usageAllowance = 0,
    speedRequested = null,
    monthlyPrice = 0.0,
    connectionFee = 0.0,
    contractTerm = 0,
    addressID = null,
    serviceNumber = null,
    contactID = 0,
    bundleId = 0,
    serviceLevelId = '',
    sqSuccess = false,
    dataBackup = null,
    modemRequired = false,
    upgrade = false,
  } = {}) {
    this.internetID = internetID;
    this.orderID = orderID;
    this.internetType = internetType;
    this.ratePlanID = ratePlanID;
    this.usageAllowance = usageAllowance;
    this.speedRequested = speedRequested;
    this.monthlyPrice = monthlyPrice;
    this.connectionFee = connectionFee;
    this.contractTerm = contractTerm;
    this.addressID = addressID;
    this.serviceNumber = serviceNumber;
    this.contactID = contactID;
    this.bundleId = bundleId;
    this.serviceLevelId = serviceLevelId;
    this.sqSuccess = sqSuccess;
    this.dataBackup = dataBackup;
    this.modemRequired = modemRequired;
    this.upgrade = upgrade;
  }
}

export function createInternet(data) {
  return Object.freeze(new Internet(data));
}
